/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum NinjaSubscriptionPlan {
  PRO = 'pro',
  TEAMS_PRO = 'teams_pro',
  ULTRA = 'ultra',
  TEAMS_ULTRA = 'teams_ultra',
  STANDARD = 'standard',
  TEAMS_STANDARD = 'teams_standard',
  SUPERNINJA_STANDARD = 'superninja_standard',
  SUPERNINJA_PRO = 'superninja_pro',
  SUPERNINJA_ULTRA = 'superninja_ultra',
  SUPERNINJA_MAX = 'superninja_max',
  BUSINESS_SUPERNINJA_PRO = 'business_superninja_pro',
  BUSINESS_SUPERNINJA_ULTRA = 'business_superninja_ultra',
  BUSINESS_SUPERNINJA_MAX = 'business_superninja_max',
  CREDIT_PRO = 'credit_pro',
  CREDIT_BUSINESS_PRO = 'credit_business_pro',
  INTERNAL_UNLIMITED = 'internal_unlimited',
  TEAMS_SUPERNINJA_ULTRA = 'teams_superninja_ultra',
}
